<template>
  <div>
    <h4>{{title}}</h4>
    <p class="sub">{{SubTitle}}</p>
    <div class="con" v-html="Content"></div>
  </div>
</template>
<script>
export default {
  name: "detail",
  data() {
    return {
      title: "",
      SubTitle: "",
      Content: ""
    };
  },
  created() {
    this.getData(this.listID);
  },

  methods: {
    getData() {
      this.$axios({
        method: "post",
        url: "https://auth.zkey.cc/api/Notice/GetDetails",
        headers: {
          "Content-Type": "application/json"
        },
        // withCredentials: true
        data: JSON.stringify({
          ID: this.listID
        })
      })
        .then(res => {
          this.title = res.data.model.Theme;
          this.SubTitle = res.data.model.SubTheme;
          this.Content = res.data.model.Content;   
          
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  props: ["listID"]
};
</script>

<style scoped>
h4 {
  text-align: center;
}
p.sub {
  text-align: right;
  font-size: 16px;
  color: #666;
  line-height: 48px;
}
.con{
  overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/components/tabs/detail.vue